<template>
  <BaseButton
    variant="tertiary"
    icon="plus"
    size="md"
    color="v1-grey-8"
    @click="$emit('edit')"
    v-if="!hasAnyTranslations"
  >
    {{ $t("menu_languages.btn_add") }}
  </BaseButton>
  <div class="current-language-menu-bar" v-else>
    <div class="qrw-button-text-md gap-column-2xs current-language" @click="show_tooltip = true">
      <img
        :src="`/flags/${currentLocaleOrOriginal}.png`"
        class="language-icon"
      />
      {{ language_names[currentLocaleOrOriginal] }}
    </div>
    <BaseDivider vertical style="height: 24px" color="v1-grey-4" />
    <BaseButton
      variant="tertiary"
      size="md"
      color="v1-grey-8"
      icon="menu"
      @click="show_tooltip = true"
    />

    <div class="tooltip-backdrop" @click="show_tooltip = false" v-if="show_tooltip"></div>
    <MenuTranslationsTooltip class="tooltip-box"
      @close="show_tooltip = false"
      @edit="$emit('edit')"
      @add="onAddRequested"
      v-if="show_tooltip"/>
  </div>
</template>

<script>
import LanguageNames from "@/i18n/language_names.js";

import MenuTranslationsTooltip from "@/components/menu/MenuTranslationsTooltip.vue";

export default {
  data() {
    return {
      language_names: LanguageNames,

      show_tooltip: false
    };
  },
  methods: {
    onAddRequested() {
      this.$emit('add');
    }
  },
  computed: {
    menu() {
      return this.$store.state.menu.current;
    },
    hasAnyTranslations() {
      return this.menu.original_locale;
    },
    currentLocaleOrOriginal() {
      return this.$store.state.menu.current_locale || this.menu.original_locale;
    },
  },
  components: {
    MenuTranslationsTooltip,
  },
};
</script>

<style scoped>
.current-language-menu-bar {
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  position: relative;
}

.language-icon {
  width: 16px;
  height: 16px;
  min-height: 16px;
  margin-bottom: 2px;
}

.current-language {
  align-items: center;
  align-content: center;
  cursor: pointer;
}

.tooltip-box {
  position: absolute;
  z-index: 10;
  top: 32px;
  right: 0;
}

.tooltip-backdrop {
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 9;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.24);
}
</style>
